$(document).ready(function() {
  $('#gotop').live('click', function() {
    $(window).scrollTo(0, 800);
    return false;
  });
  $('.cart-popup').live('click', function(e) {
    var id = $(this).attr('id');
    var product = $(this).parent().parent().parent().parent();
    var product_html = product.html();
    product.find('form#' + id).lightbox_me({
      centered: true,
      zIndex: 8888,
      closeSelector: '#close-img',
      destroyOnClose: false,
      onClose: function() {
        product.html(product_html);
        product.find('button').hide();
      }
    });
    e.preventDefault();
  });
  $('.cart-plus').live('click', function() {
    var value = $(this).parent().find('input.item-quantity').val();
    $(this).parent().find('input.item-quantity').val(parseInt(value) + 1);
  });
  $('.cart-minus').live('click', function() {
    var value = $(this).parent().find('input.item-quantity').val();
    if (value <= 0)
      return false;

    $(this).parent().find('input.item-quantity').val(parseInt(value) - 1);
  });
  $(".product").live("mouseover", function() {
    $(this).find('.hover-btn1').show();
    $(this).find('.hover-btn2').show();
  });
  $(".product").live("mouseleave", function() {
    $(this).find('.hover-btn1').hide();
    $(this).find('.hover-btn2').hide();
  }); 

  $("#tabs li").click(function() {
    // Social Box Jquery
    $("#tabs li").removeClass('active');

    $(this).addClass("active");

    $(".tab_content").hide();

    var selected_tab = $(this).find("a").attr("href");

    $(selected_tab).fadeIn(200);

    return false;
  });
});